export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/MapWorker.worker.9bfcccbb.worker.js");
}
